import { Progress } from "~/atoms/progress";

interface WorkflowProgressValue {
  completedSteps?: number;
  totalSteps?: number;
}

interface WorkflowProgressProps {
  workflow?: WorkflowProgressValue | null;
  completedSteps?: number;
  totalSteps?: number;
}

const resolveWorkflowProgress = ({
  workflow,
  completedSteps,
  totalSteps,
}: WorkflowProgressProps): WorkflowProgressValue | null => {
  if (workflow) {
    return workflow;
  }

  if (completedSteps === undefined || totalSteps === undefined) {
    return null;
  }

  return { completedSteps, totalSteps };
};

export const WorkflowProgress = (props: WorkflowProgressProps) => {
  const progress = resolveWorkflowProgress(props);
  const total = progress?.totalSteps ?? 0;
  const completed = progress?.completedSteps ?? 0;

  if (!progress || total <= 0) {
    return null;
  }

  const percentage = (completed / total) * 100;

  return (
    <div className="flex items-center gap-2">
      <Progress value={percentage} />
      <span className="text-muted-foreground text-sm">
        {completed}/{total}
      </span>
    </div>
  );
};
